import { render } from "./HomeModals.vue?vue&type=template&id=2f198290"
import script from "./HomeModals.vue?vue&type=script&lang=js"
export * from "./HomeModals.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__